import { render, staticRenderFns } from "./ActionCard.vue?vue&type=template&id=2f675a07"
import script from "./ActionCard.vue?vue&type=script&lang=js"
export * from "./ActionCard.vue?vue&type=script&lang=js"
import style0 from "./ActionCard.vue?vue&type=style&index=0&id=2f675a07&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports